module.exports = __webpack_public_path__ + "img/vaidesn_lg.a7c806b3.jpg";